import React, { useState } from 'react';
import { Heart, Brain, Users, Award, Target, Shield, Clock, MapPin, Phone, Mail, CheckCircle, Star, Activity, Lightbulb, Home, Lock, Monitor, Globe, ChevronLeft, ChevronRight, Baby, Calendar } from 'lucide-react';

const About = () => {
  const [currentCenterIndex, setCurrentCenterIndex] = useState(0);
  const teamMembers = [
    {
      name: "DR PRATHEESH PJ",
      department: "CEO & Founder",
      role: "Consultant Psychiatrist",
      image: "https://s3.thoughtdiary.ai/mysolace/web/profile/pratheesh.jpeg",
    },
    {
      name: "DR AMEER SUHAIL RAZAQ",
      department: "Asst. CEO",
      // role: "Software Engineer",
      image: "/static/img/ameer.jpeg",
    },
    {
      name: "MS ASHAPOORNIMA R",
      department: "CTO",
      role: "Software Engineer",
      image: "https://s3.thoughtdiary.ai/mysolace/web/profile/IMG_1761.PNG",
    }
  ];

  const centers = [
    {
      name: "Solace Neurobehavioral And Child Guidance Center",
      address: "Pipeline road, Near Karanakodam Kurisupally South, Janatha cross road, Palarivattom, Kochi, Kerala 682025",
      image: "https://solacekids.in/assets/images/centers/palarivattom.png",
      directionsUrl: "https://maps.app.goo.gl/DqZgPjUHUaRciQXe7"
    },
    {
      name: "Solace Premier",
      address: "Kuzhikaattumula Nilampathinjamughal Road, Kakkanad, Kochi 682030",
      image: "https://solacekids.in/assets/images/centers/premier.png",
      directionsUrl: "https://maps.app.goo.gl/bxi4MZ2TCm3FwiDR8"
    },
    {
      name: "Solace Kids and CAP",
      address: "Kuzhikkattumoola, Kakkanad, Kochi, Kerala 682030",
      image: "https://solacekids.in/assets/images/centers/kids.png",
      directionsUrl: "https://maps.app.goo.gl/MdcXZSveY53VzkUH6"
    },
    {
      name: "Solace Village",
      address: "Elampathu Road, Nilampathinjamugal Rajagiri Valley Rd, P O, Kakkanad, Kochi, Kerala 682039",
      image: "https://solacekids.in/assets/images/centers/village.png",
      directionsUrl: "https://maps.app.goo.gl/b9csEj8pYh9b7ePi9"
    },
    {
      name: "Solace Senior Care",
      address: "Near Olimugal Juma Masjid, Kakkanad 682030",
      image: "https://s3.thoughtdiary.ai/solace-seniorcare/Gallery/SAN04239.JPG",
      directionsUrl: "https://maps.app.goo.gl/jstdyLmQnEpqzWda7?g_st=aw"
    }
  ];

  const specialties = [
    {
      icon: <Brain className="w-6 h-6" />,
      title: "Expertise in Psychology",
      description: "Detailed mental health evaluation and treatment"
    },
    {
      icon: <Home className="w-6 h-6" />,
      title: "Best Inpatient Facilities",
      description: "State-of-the-art comfortable care environment"
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: "Tailored Treatment Programs",
      description: "Personalized care plans for individual needs"
    },
    {
      icon: <Baby className="w-6 h-6" />,
      title: "Child-Centric Development Center",
      description: "Specialized care for children's mental health"
    },
    {
      icon: <Heart className="w-6 h-6" />,
      title: "Collaborative Family Care",
      description: "Involving families in the healing process"
    },
    {
      icon: <Lock className="w-6 h-6" />,
      title: "Strict Confidentiality & Data Privacy",
      description: "Complete privacy protection for all patients"
    },
    {
      icon: <Monitor className="w-6 h-6" />,
      title: "Comprehensive Hybrid Care",
      description: "Online + Offline treatment options"
    },
    {
      icon: <Globe className="w-6 h-6" />,
      title: "International Presence & Remote Care",
      description: "Global reach with remote consultation services"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <section className="relative min-h-[68vh] overflow-hidden bg-gray-950 text-white">
        <img
          src="https://s3.thoughtdiary.ai/mysolace/web/profile/groupphoto.jpg"
          alt="Solace Neuro care team"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-950 via-gray-950/78 to-gray-950/24"></div>
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-gray-50 to-transparent"></div>

        <div className="relative flex min-h-[68vh] items-end px-4 pb-10 pt-28 sm:px-6 lg:px-8 lg:pb-14">
          <div className="w-full">
            <div className="max-w-4xl">
              <p className="mb-5 inline-flex items-center rounded-full border border-white/25 bg-white/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.28em] text-primary-100 backdrop-blur">
                About Us
              </p>
              <h1 className="text-4xl font-bold leading-tight text-white md:text-6xl lg:text-7xl">
                SOLACE NEURO
              </h1>
              <p className="mt-6 max-w-3xl text-lg leading-relaxed text-white/86 md:text-2xl">
                Where healing minds find their path to wellness through compassionate psychiatric care,
                innovative treatment approaches, and dedicated support.
              </p>
            </div>

            <div className="mt-10 grid max-w-5xl grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/15 bg-white/15 shadow-2xl backdrop-blur sm:grid-cols-3">
              <div className="bg-gray-950/55 px-6 py-5">
                <p className="text-3xl font-bold text-primary-200">15+</p>
                <p className="mt-1 text-sm font-medium text-white/78">Years of excellence</p>
              </div>
              <div className="bg-gray-950/55 px-6 py-5">
                <p className="text-3xl font-bold text-primary-200">10,000+</p>
                <p className="mt-1 text-sm font-medium text-white/78">Lives touched</p>
              </div>
              <div className="bg-gray-950/55 px-6 py-5">
                <p className="text-3xl font-bold text-primary-200">40+</p>
                <p className="mt-1 text-sm font-medium text-white/78">Expert professionals</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:grid lg:grid-cols-[1.05fr_0.95fr] gap-8 lg:gap-14 items-center">
            <div className="order-2 lg:order-1 max-w-3xl">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4 lg:mb-6" style={{color: '#00A785'}}>
                Our Story
              </h2>
              <div className="space-y-3 text-base lg:text-lg text-gray-600 leading-relaxed">
                <p>
                  Solace is a leading mental health care organization, found in 2011 on the principle
                  of providing caring and evidence-based health services. With a focus on individualized care, 
                  the organization aims to assist people at all stages of life, from childhood to older adulthood.
                </p>
                <p>
                  With years of experience in providing health services, the team assists people with various mental 
                  health issues such as depression, anxiety, bipolar disorders, psychosis, personality disorders, 
                  de-addiction, and many more. With the patient-centric approach, health services are delivered in 
                  an accessible, effective, and caring manner.
                </p>
                <p>
                  Developed in a safe and soothing environment where the primary goal is to enable individuals to attain
                  emotional stability and live a healthy lifestyle.
                </p>
              </div>
            </div>
            <div className="relative order-1 lg:order-2 w-full max-w-2xl">
              <div className="absolute -inset-4 rounded-[2rem] bg-primary-50"></div>
              <div className="absolute -bottom-5 -left-5 h-32 w-32 rounded-full bg-primary-100"></div>
              <img 
                src="https://www.shutterstock.com/image-vector/problem-solving-psychotherapy-concept-social-600nw-2394102895.jpg" 
                alt="Psychotherapy illustration"
                className="relative aspect-[5/4] w-full rounded-[1.75rem] border border-primary-100 object-cover object-center shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20" style={{backgroundColor: '#00A785'}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Our Purpose
            </h2>
            <p className="text-xl text-green-50 max-w-3xl mx-auto">
              Driving excellence in mental healthcare
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
              <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mb-6">
                <Target className="w-6 h-6 text-primary-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
              <p className="text-gray-600 leading-relaxed">
                To bridge the growing mental health gap by delivering confidential, 
                evidence-based psychiatric and psychological care through reliable digital systems.
              </p>
            </div>
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
              <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mb-6">
                <Star className="w-6 h-6 text-primary-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h3>
              <p className="text-gray-600 leading-relaxed">
                To build a world where professional mental healthcare is accessible 24×7 in the digital space, 
                ensuring qualified and compassionate support anytime, anywhere.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Specialties Section */}
    <section className="py-20" style={{ backgroundColor: 'rgb(243 244 246 / 1)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2" style={{ color: '#00A785' }}>
            Our Specialties
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto leading-relaxed">
            Comprehensive mental health services for your unique needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {specialties.map((specialty, index) => (
            <div
              key={index}
              className="bg-white hover:bg-[#f0fdf8] transition-colors duration-200 p-6 flex gap-4 items-start rounded-2xl border border-gray-200"
            >
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: '#e6f7f2' }}
              >
                <span style={{ color: '#00A785' }}>{specialty.icon}</span>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-1 leading-snug">
                  {specialty.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed">
                  {specialty.description}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>

      {/* Team Section */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{color: '#00A785'}}>
              Executive Leadership
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Meet the C-suite guiding Solace's clinical vision, operations, and digital innovation.
            </p>
          </div>
          <div className="flex justify-center gap-16 flex-wrap">
            {teamMembers.map((member, index) => (
              <div key={index} className="flex flex-col items-center w-44">
                <div className="w-40 h-52 rounded-2xl overflow-hidden border-2 border-green-100 mb-3 bg-gray-50">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <span className="text-xs font-medium px-3 py-1 rounded-full mb-2" style={{backgroundColor: '#E1F5EE', color: '#085041'}}>
                  {member.department}
                </span>
                <p className="text-sm font-semibold text-gray-900 text-center leading-tight">{member.name}</p>
                {member.role && <p className="text-xs text-gray-500 text-center mt-1">{member.role}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Centers Section */}
      <section className="py-20" style={{backgroundColor: 'rgb(243 244 246 / 1)'}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{color: '#00A785'}}>
              Our Centers
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Visit us at any of our state-of-the-art facilities across Kerala
            </p>
          </div>
          
          {/* Centers Slider - 3 Cards Per Row */}
          <div className="relative">
            {/* Cards Container */}
            <div className="overflow-hidden mb-6">
              <div 
                className="flex gap-6 transition-transform duration-300 ease-in-out lg:hidden"
                style={{ transform: `translateX(-${currentCenterIndex * (320 + 24)}px)` }}
              >
                {centers.map((center, index) => (
                  <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow flex-shrink-0 flex flex-col" style={{width: '320px'}}>
                    {/* Center Image - Full Width */}
                    <div className="w-full h-64 bg-white flex items-center justify-center">
                      <img 
                        src={center.image} 
                        alt={center.name}
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                    
                    {/* Center Content - Simplified like Doctors */}
                    <div className="p-4 flex flex-col flex-1">
                      <h3 className="text-sm font-bold mb-1" style={{color: '#00A785'}}>{center.name}</h3>
                      <div className="flex items-start text-xs text-gray-600 mb-2">
                        <MapPin className="w-3 h-3 mr-1 text-gray-400 flex-shrink-0 mt-0.5" />
                        <p className="line-clamp-3">{center.address}</p>
                      </div>
                      
                      {/* Get Direction Link - Always at Bottom */}
                      <div className="mt-auto">
                        <a 
                          href={center.directionsUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary-600 hover:text-primary-700 underline text-sm font-medium inline-flex items-center space-x-2"
                        >
                          <MapPin className="w-4 h-4 flex-shrink-0" />
                          <span>Get Directions</span>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              {/* Desktop View */}
              <div 
                className="hidden lg:flex gap-6 transition-transform duration-300 ease-in-out"
                style={{ transform: `translateX(-${currentCenterIndex * (380 + 24)}px)` }}
              >
                {centers.map((center, index) => (
                  <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow flex-shrink-0 flex flex-col" style={{width: '380px'}}>
                    {/* Center Image - Full Width */}
                    <div className="w-full h-64 bg-white flex items-center justify-center">
                      <img 
                        src={center.image} 
                        alt={center.name}
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                    
                    {/* Center Content - Simplified like Doctors */}
                    <div className="p-4 flex flex-col flex-1">
                      <h3 className="text-sm font-bold mb-1" style={{color: '#00A785'}}>{center.name}</h3>
                      <div className="flex items-start text-xs text-gray-600 mb-2">
                        <MapPin className="w-3 h-3 mr-1 text-gray-400 flex-shrink-0 mt-0.5" />
                        <p className="line-clamp-3">{center.address}</p>
                      </div>
                      
                      {/* Get Direction Link - Always at Bottom */}
                      <div className="mt-auto">
                        <a 
                          href={center.directionsUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary-600 hover:text-primary-700 underline text-sm font-medium inline-flex items-center space-x-2"
                        >
                          <MapPin className="w-4 h-4 flex-shrink-0" />
                          <span>Get Directions</span>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Navigation Buttons - Bottom Center */}
            <div className="flex justify-center items-center space-x-4">
              <button 
                onClick={() => setCurrentCenterIndex(Math.max(0, currentCenterIndex - 1))}
                disabled={currentCenterIndex === 0}
                className={`border border-gray-200 rounded-lg p-3 shadow-lg hover:shadow-xl transition-shadow ${
                  currentCenterIndex === 0 
                    ? 'bg-gray-100 text-gray-300 cursor-not-allowed' 
                    : 'bg-white text-gray-600 hover:bg-gray-50'
                }`}
              >
                <ChevronLeft className="w-6 h-6" />
              </button>
              
              <button 
                onClick={() => {
                  if (window.innerWidth >= 1024) {
                    setCurrentCenterIndex(Math.min(centers.length - 3, currentCenterIndex + 3));
                  } else {
                    setCurrentCenterIndex(Math.min(centers.length - 1, currentCenterIndex + 1));
                  }
                }}
                disabled={window.innerWidth >= 1024 ? currentCenterIndex >= centers.length - 3 : currentCenterIndex === centers.length - 1}
                className={`border border-gray-200 rounded-lg p-3 shadow-lg hover:shadow-xl transition-shadow ${
                  window.innerWidth >= 1024 ? (currentCenterIndex >= centers.length - 3 ? 'bg-gray-100 text-gray-300 cursor-not-allowed' : 'bg-white text-gray-600 hover:bg-gray-50') : (currentCenterIndex === centers.length - 1 ? 'bg-gray-100 text-gray-300 cursor-not-allowed' : 'bg-white text-gray-600 hover:bg-gray-50')
                }`}
              >
                <ChevronRight className="w-6 h-6" />
              </button>
            </div>
          </div>
        </div>
      </section>

      </div>
  );
};

export default About;
